import { render, staticRenderFns } from "./3.vue?vue&type=template&id=187c202b&scoped=true&"
var script = {}
import style0 from "./3.vue?vue&type=style&index=0&id=187c202b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187c202b",
  null
  
)

export default component.exports